import { render, staticRenderFns } from "./MassChangeBrand.vue?vue&type=template&id=13f58fda&scoped=true&"
import script from "./MassChangeBrand.vue?vue&type=script&lang=js&"
export * from "./MassChangeBrand.vue?vue&type=script&lang=js&"
import style0 from "./MassChangeBrand.vue?vue&type=style&index=0&id=13f58fda&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13f58fda",
  null
  
)

export default component.exports